import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useOffline } from '../hooks/usePWA';

const { FiWifiOff, FiWifi, FiCloud, FiHardDrive } = FiIcons;

const OfflineIndicator = () => {
  const { isOffline } = useOffline();

  return (
    <AnimatePresence>
      {isOffline && (
        <motion.div
          className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50"
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -100, opacity: 0 }}
          transition={{ type: 'spring', damping: 20 }}
        >
          <div className="bg-orange-500/90 backdrop-blur-sm text-white px-4 py-2 rounded-full shadow-lg border border-orange-400/50">
            <div className="flex items-center text-sm font-medium">
              <SafeIcon icon={FiWifiOff} className="mr-2 text-lg" />
              <span>You're offline</span>
              <div className="ml-2 flex items-center text-xs opacity-80">
                <SafeIcon icon={FiHardDrive} className="mr-1" />
                Local mode
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const ConnectionStatus = ({ className = "" }) => {
  const { isOffline } = useOffline();

  return (
    <div className={`flex items-center text-sm ${className}`}>
      <SafeIcon 
        icon={isOffline ? FiWifiOff : FiWifi} 
        className={`mr-1 ${isOffline ? 'text-orange-400' : 'text-green-400'}`} 
      />
      <span className={isOffline ? 'text-orange-300' : 'text-green-300'}>
        {isOffline ? 'Offline' : 'Online'}
      </span>
    </div>
  );
};

export default OfflineIndicator;